import { ReactNode } from 'react';
import styles from './WizardShell.module.css';

interface IWizardShell {
  step?: number;
  totalSteps?: number;
  title: string;
  nextTitle?: string;
  helper?: string;
  children: ReactNode;
}

export function WizardShell({
  step,
  totalSteps,
  title,
  nextTitle,
  helper,
  children,
}: IWizardShell) {
  /* The progress ring only means something inside the multi-step proposal. */
  const showProgress = !!step && !!totalSteps && totalSteps > 1;
  const percent = showProgress ? Math.round((step / totalSteps) * 100) : 0;

  return (
    <div className={styles.layout}>
      <aside className={styles.aside}>
        <div className={styles.asideInner}>
          {showProgress && (
            <div
              className={styles.ring}
              style={{
                background: `conic-gradient(var(--primary) ${percent}%, var(--background-input) ${percent}%)`,
              }}
            >
              <div className={styles.ringInner}>
                {step} de {totalSteps}
              </div>
            </div>
          )}
          <h1 className={styles.title}>{title}</h1>
          {nextTitle && <p className={styles.next}>Próximo: {nextTitle}</p>}
          {helper && <p className={styles.helper}>{helper}</p>}
        </div>
      </aside>
      <div className={styles.panel}>
        <main className={styles.main}>{children}</main>
      </div>
    </div>
  );
}

interface IWizardSection {
  number?: number;
  title: string;
  children: ReactNode;
}

export function WizardSection({ number, title, children }: IWizardSection) {
  return (
    <section className={styles.section}>
      <div className={styles.sectionHeader}>
        {number !== undefined && (
          <span className={styles.sectionNumber}>{number}</span>
        )}
        <h2 className={styles.sectionTitle}>{title}</h2>
      </div>
      {children}
    </section>
  );
}
